import { gql } from "@apollo/client";

export const GET_ALL_RECORDS = gql`
 query GetAllRecords($input: RecordInput!) {
  GetAllRecords(input: $input) {
    totalCount
    records {
      id
      from
      to
      date
      dueDate
      clientName
      department
      completedDate
      historyCount
      processType
      priority
      noofQuotes
      quoteType
      requestId
      insuredName
      subject
      metaInfo {
        startTime
        endTime
        taskType
      }
      employeeInfo {
        createdByName
        reportingTo
      }
    }
  }
}

`;

export const GET_TIME_LOGS = gql`
  query GetTimeRecord($from: String, $to: String $startOfMonth:String, $endOfMonth:String,$page:Int,$loginUserId:String) {
    GetTimeRecord(from: $from, to: $to,startOfMonth:$startOfMonth,endOfMonth:$endOfMonth,page:$page,loginUserId:$loginUserId) {
    records{
       id
      userId
      requestId
      clientName
      taskType
      department
      startTime
      updatedAt
      endTime
      overrideHistory {
        overriddenBy
        previousstartTime
        previousendTime
        previousTask
        changedArea
        updatedTime
      }
      employeeDetails {
        firstname
        lastname
        email
      }
}
      totalCount
    }
  }
`;
